export default __webpack_public_path__ + "static/media/RhymesCountAlong_13.bf1b179c.png";